import { render } from "./acerca-de.vue?vue&type=template&id=78284f4a&scoped=true"
import script from "./acerca-de.vue?vue&type=script&lang=js"
export * from "./acerca-de.vue?vue&type=script&lang=js"

import "./acerca-de.vue?vue&type=style&index=0&id=78284f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78284f4a"]])

export default __exports__